import axios from 'axios'
import $store from '@/store/store.js'

const token = () => {
	let user = $store.getters.user
	return user.maestroAuth
}

const onError = (error) => {
	if (error.message === 'Network Error') {
		$store.commit('set_maestro_api_status', false)
	}
}
const onSuccess = () => {
	$store.commit('set_maestro_api_status', true)
}

const ApiMaestro = {
	install (Vue, options) {
		Vue.prototype.$ApiMaestro = {

			jobrequest_read (job_id) {
				return new Promise((resolve, reject) => {
					let jobRequestResponse = null
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/jobrequest/${job_id}/`,
						method: 'get',
						headers: { Authorization: `Token ${token()}` }
					}
					axios(options)
						.then(response => {
							onSuccess()
							jobRequestResponse = response
							let jobdescriptorVersionId = response.data.descriptor.split('/').splice(-2)[0]
							options.baseURL = `${window.appConfig._$5u7vw2}api/jobdescriptorversion/${jobdescriptorVersionId}/`
							return axios(options)
						})
						.then(response => {
							let descriptorId = parseInt(response.data.descriptor.split('/').splice(-2)[0])
							jobRequestResponse.data.descriptor_id = descriptorId
							let tasksDesc = window.vm.$commons.arrayToObject(response.data.tasks, 'id')
							jobRequestResponse.data.tasks = jobRequestResponse.data.tasks.filter(task => {
								return !task.parent
							})
							jobRequestResponse.data.tasks = jobRequestResponse.data.tasks.map(task => {
								let taskdescriptorVersionId = task.descriptor
								task.trigger = tasksDesc[taskdescriptorVersionId].trigger
								task.label = tasksDesc[taskdescriptorVersionId].label
								task.operating_zone = tasksDesc[taskdescriptorVersionId].operating_zone
								task.operator_id = ''
								if (task.operator) {
									task.operator_id = task.operator.id
								}
								return task
							})
							resolve(jobRequestResponse)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			jobrequest_actions_read (job_id) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/jobrequest/${job_id}/actions/`,
						method: 'get',
						headers: { Authorization: `Token ${token()}` }
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			jobrequest_actions_create (job_id, action) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/jobrequest/${job_id}/actions/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						},
						data: {
							action: action
						}
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			jobrequest_create (job) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/jobrequest/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						},
						data: {
							descriptor: `/api/jobdescriptor/${job.jd_id}/`,
							version: job.jd_version,
							auto_start: true,
							parameters: JSON.stringify(job.parameters),
							priority: job.priority || 0
						}
					}
					if (job.parent_jobrequest_id) {
						options.data.parent_jobrequest_id = job.parent_jobrequest_id
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			jobrequest_restart (job_id) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/jobrequest/${job_id}/restart/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						}
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			jobrequest_complete (job_id) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/jobrequest/${job_id}/complete/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						}
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			jobrequest_cancel (job_id) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/jobrequest/${job_id}/cancel/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						}
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			jobrequest_due_date (job_id, due_date) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/jobrequest/${job_id}/due_date/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						},
						data: {
							due_date: due_date
						}
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			jobrequest_billing_status (job_id, billing_status) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/jobrequest/${job_id}/billing_status/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						},
						data: {
							status: billing_status
						}
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			jobrequest_restartables (job_id) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/jobrequest/${job_id}/restartables/`,
						method: 'get',
						headers: { Authorization: `Token ${token()}` }
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			jobrequest_search (search, jd_id) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/jobrequest/`,
						method: 'get',
						headers: { Authorization: `Token ${token()}` },
						params: {
							search: search
						}
					}
					if (jd_id) options.params.descriptor__descriptor = jd_id
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			jobrequest_index (job_id) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/jobrequest/${job_id}/index/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						}
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			jobdescriptor_read (jd_id) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/jobdescriptor/${jd_id}/`,
						method: 'get',
						headers: { Authorization: `Token ${token()}` }
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			jobdescriptor_source (jd_id) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/jobdescriptor/${jd_id}/source/`,
						method: 'get',
						headers: { Authorization: `Token ${token()}` }
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			jobdescriptorversion_read (jd_id) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/jobdescriptorversion/${jd_id}/`,
						method: 'get',
						headers: { Authorization: `Token ${token()}` }
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			jobdescriptorversion_source (jd_id) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/jobdescriptorversion/${jd_id}/source/`,
						method: 'get',
						headers: { Authorization: `Token ${token()}` }
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			jobdescriptor_check (jd) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/jobdescriptor/check/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						},
						data: jd
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			jobdescriptor_create (jd) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/jobdescriptor/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						},
						data: jd
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			jobdescriptor_update (jdId, jd) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/jobdescriptor/${jdId}/`,
						method: 'put',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						},
						data: jd
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			task (task_id) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/task/${task_id}/`,
						method: 'get',
						headers: { Authorization: `Token ${token()}` }
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			task_test (data) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/task/test/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						},
						data: data
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			task_restart (task_id) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/task/${task_id}/restart/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						}
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			task_assign (task_id, to) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/task/${task_id}/assign/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						},
						data: {to: to}
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			task_validation_read (task_id) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/task/${task_id}/validation/`,
						method: 'get',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						}
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			task_validation_create (task_id, fields) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/task/${task_id}/validation/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						},
						data: fields
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			task_validation_save (task_id, fields) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/task/${task_id}/validation/save/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						},
						data: fields
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			task_validation_status (task_id) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/task/${task_id}/validation/status/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						}
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			task_validation_release (task_id) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/task/${task_id}/validation/release/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						}
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			worker_list () {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/workers.json`,
						method: 'get',
						headers: { Authorization: `Token ${token()}` }
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			comment_create (job_id, what) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/comment/`,
						method: 'post',
						headers: {
							'content-type': 'application/x-www-form-urlencoded',
							'Authorization': `Token ${token()}`
						},
						data: `what=${what}&job_request=/api/jobrequest/${job_id}/`
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			comment_jobrequest (job_id) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/comment/${job_id}/jobrequest/`,
						method: 'get',
						headers: { 'Authorization': `Token ${token()}` }
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			host_list () {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/host/`,
						method: 'get',
						headers: { Authorization: `Token ${token()}` }
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			mapping_list () {
				const getPageItems = (url) => {
					return new Promise((resolve, reject) => {
						let options = {
							baseURL: url,
							method: 'get',
							headers: { Authorization: `Token ${token()}` }
						}
						axios(options)
							.then(response => {
								onSuccess()
								resolve(response)
							})
							.catch(error => {
								onError(error)
								reject(error)
							})
					})
				}
				return new Promise(async (resolve, reject) => {
					let items = []
					let nextUrl = `${window.appConfig._$5u7vw2}api/mapping/`
					while (nextUrl) {
						try {
							let response = await getPageItems(nextUrl)
							nextUrl = response.data.next
							items.push(...response.data.results)
						} catch (error) {
							reject(error)
						}
					}
					resolve(items)
				})
			},

			mapping_read (slug) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/mapping/${slug}/`,
						method: 'get',
						headers: { Authorization: `Token ${token()}` }
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			mapping_update (data, slug) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/mapping/${slug}/`,
						method: 'put',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						},
						data: {
							datas: JSON.stringify(data)
						}
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			search_page (query) {
				let search = query.search === undefined || query.search === null ? '' : query.search
				let category = query.category === undefined || query.category === null ? '' : query.category
				let project = query.project === undefined || query.project === null ? '' : query.project
				let ordering = '-creation_date' // most recent first
				let limit = query.limit
				let offset = query.offset
				let url = window.appConfig._$5u7vw2
				url += `api/page/?search=${search}`
				url += `&category=${category}`
				url += `&project=${project}`
				url += `&offset=${offset}`
				url += `&limit=${limit}`
				url += `&ordering=${ordering}`
				if (query.is_active) url += `&is_active=${query.is_active}`
				if (query.is_public) url += `&is_public=${query.is_public}`
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: url,
						method: 'get',
						headers: { Authorization: `Token ${token()}` }
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			get_page (slug) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/page/${slug}/`,
						method: 'get',
						headers: { Authorization: `Token ${token()}` }
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			search_tickets (query) {
				let search = query.search === undefined || query.search === null ? '' : `&search=${query.search}`
				let category = query.category === undefined || query.category === null ? '' : `&category=${query.category}`
				let project = query.project === undefined || query.project === null ? '' : `&project=${query.project}`
				let status = query.status === undefined || query.status === null ? '' : `&status=${query.status}`
				let assigned = query.assigned === undefined || query.assigned === null ? '' : `&assigned=${query.assigned}`
				let ordering = 'ordering=-creation_date' // most recent first
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/ticket/?${ordering}${search}${category}${project}${status}${assigned}`,
						method: 'get',
						headers: { Authorization: `Token ${token()}` }
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			search_tickets_direct (query) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: query,
						method: 'get',
						headers: { Authorization: `Token ${token()}` }
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			get_ticket (ticket_ref) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/ticket/?reference=${ticket_ref}`,
						method: 'get',
						headers: { Authorization: `Token ${token()}` }
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			add_ticket_comment (ticket_id, comment, privateComment = false) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/ticket/${ticket_id}/add_comment/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						},
						data: {
							what: comment
						}
					}
					if (privateComment) options.data.event = 3
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			close_ticket (ticket_id, human_time) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/ticket/${ticket_id}/close_ticket/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						}
					}
					if (human_time) {
						options.data = {
							human_time: human_time
						}
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			soft_close_ticket (ticket_id, human_time) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/ticket/${ticket_id}/soft_close_ticket/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						}
					}
					if (human_time) {
						options.data = {
							human_time: human_time
						}
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			backlog_ticket (ticket_id) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/ticket/${ticket_id}/backlog_ticket/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						}
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			reopen_ticket (ticket_id) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/ticket/${ticket_id}/reopen_ticket/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						}
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			comment_and_close_ticket (ticket_id, comment, human_time) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/ticket/${ticket_id}/comment_and_close_ticket/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						},
						data: {
							what: comment
						}
					}
					if (human_time) {
						options.data.human_time = human_time
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			update_ticket (ticket_id, data) {
				return new Promise((resolve, reject) => {
					let acceptedKeys = [
						'assigned',
						'estimated_time',
						'estimated_difficulty',
						'category',
						'priority_level'
					]
					for (const key in data) {
						if (acceptedKeys.indexOf(key) === -1) {
							reject(new Error(`Key ${key} not accepted`))
							break
						}
					}
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/ticket/${ticket_id}/`,
						method: 'put',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						},
						data: data
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			post_ticket (title, what, payload) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/ticket/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						},
						data: {
							title: title,
							payload: JSON.stringify(payload),
							project: 1,
							category: 0,
							what: what
						}
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			reformulate_ticket (content) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/ticket/reformulate/?content=${content}`,
						method: 'get',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						}
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			summarize_ticket (ticket_id) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/ticket/${ticket_id}/summary/`,
						method: 'post',
						headers: {
							'content-type': 'application/json',
							'Authorization': `Token ${token()}`
						}
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},

			get_or_create_account (email, name) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$5u7vw2}api/gravity/welcome/`,
						method: 'get',
						headers: {
							'content-type': 'application/json',
							'Authorization': window.appConfig._$1u72m8
						},
						params: {
							email: email
						}
					}
					axios(options)
						.then(response => {
							onSuccess()
							if (response.data.token.indexOf('9fb689d1-2dda-4da1-8e5d-03da3bc663') === 0) {
								let options = {
									baseURL: `${window.appConfig._$5u7vw2}api/gravity/onboard/`,
									method: 'post',
									headers: {
										'content-type': 'application/json',
										'Authorization': window.appConfig._$1u72m8
									},
									data: {
										email: email,
										name: name
									}
								}
								return axios(options)
							} else {
								resolve({
									maestroAuth: response.data.token,
									maestroUserId: response.data.id
								})
							}
						})
						.then(response => {
							resolve({
								maestroAuth: response.data.token,
								maestroUserId: response.data.id
							})
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			}
		}
	}
}

export default ApiMaestro



// WEBPACK FOOTER //
// ./src/api/maestro_api.js